function isLayerSelector(property) {
  return property.substr(0, 6) === '@layer';
}

export { isLayerSelector };
//# sourceMappingURL=isLayerSelector.esm.js.map
